// NewsModel.js
class NewsModel {
    constructor(title, description, url, urlToImage, author,source) {
      this.title = title;
      this.description = description;
      this.url = url;
      this.urlToImage = urlToImage;
      this.author = author;
      this.source = source;
    }
  }
  
  export default NewsModel;
  